export default __webpack_public_path__ + "static/media/PAFI_Pengumuman RUPS 2025.f79fe2ca.pdf";